globalThis.TUTORIAL = `
HHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHH
HIIIIIIIIIIIIIIIIIIIII                                           H
HIIIIIIIIIIIIIIHHIIIIII           II                       II    H
HIIHHIIIIIIIIIIHHIIIIII  III     IIIIIII        III      IIII    H
HIIHHIIIIIIIIIIIIIIIIII IIIIIII IIIIIIII III   IIII      III     H
HIIIIIIIIRRIIIIIIIIIII  IIIIII   IIIIIII IIII  I                 H
HIIIIIIIIRRIIIIIIII      IIII      II    IIII    F    F          H
HIIIIIIIIHH                I                     F   LF  F       H
HIIIIIIIIHH                                      F    F  F       H
H                                        EEEEEEEEFFFFFFFFFEEEEEEIE
H                                        E                     EIE
H               CCCCCI          P        E                      IE
H               CMMKC      IDDDDDDI      E                       E
H               CLCKC      IDDDDDDI      E                       E
H  Q            CLCKCLCI   IDDDDDDI      X   LEEL  EEEEEEI EI  EEE
H          B     LCKCLC     DDDDDD       X    EE   EEEEEE  E   EEE
H       B  B    CCCMMLC     DDDDDD       X    EE   EEEEEE  E   EEE
HHHHHHHHBBBBHHHHCCCCCCCHHHHHDDDDDDHHHHHHHEEEEEEEEEEEEEEEEEEEEEEEEE
`.trim();
